export const technicalMessageTypes = [
    {
        id: 'PING',
        label: 'Ping',
    },
    {
        id: 'USER_LOGIN',
        label: 'Login',
    },
    {
        id: 'USER_LOGOUT',
        label: 'Logout',
    },
    {
        id: 'APPLICATION_KILLED',
        label: 'Application fermée',
    },
    {
        id: 'START_PROTECTION',
        label: 'Début de la protection',
    },
    {
        id: 'STOP_PROTECTION',
        label: 'Fin de la protection',
    },
    {
        id: 'BATTERY_LEVEL',
        label: 'Niveau de batterie',
    },
    {
        id: 'DEVICE_CONNECTED',
        label: 'Application connectée',
    },
    {
        id: 'DEVICE_DISCONNECTED',
        label: 'Application déconnectée',
    },
    {
        id: 'APPLICATION_IN_BACKGROUND',
        label: 'Application mise en arrière plan',
    },
];
